import SettingsSection from "../components/SettingsSection";
import InviteTeamMembers from "./InviteTeamMembers/InviteTeamMembers";
import TeamMembersTable from "./TeamMembersTable/TeamMembersTable";
import styles from "./Team.module.scss";
import TeamNameInput from "./TeamNameInput/TeamNameInput";
import Card from "../../../ui/Card/Card";

function Team() {
  return (
    <Card className={styles.card}>
      <h2 className={styles.title}>Manage your team</h2>
      <SettingsSection label="Team name">
        <TeamNameInput />
      </SettingsSection>
      <SettingsSection
        label="Invite team members"
        description="Invite your team to collaborate"
      >
        <InviteTeamMembers />
      </SettingsSection>
      <SettingsSection
        label="Team members"
        description="Manage your existing team and change roles/permissions."
      >
        <TeamMembersTable />
      </SettingsSection>
    </Card>
  );
}

export default Team;
